/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { GaussianDensityVolumeParams, GaussianDensityVolumeVisual, UnitsGaussianDensityVolumeVisual } from '../visual/gaussian-density-volume';
import { StructureRepresentationProvider, ComplexRepresentation, StructureRepresentationStateBuilder, UnitsRepresentation } from '../representation';
import { Representation } from '../../../mol-repr/representation';
import { DirectVolume } from '../../../mol-geo/geometry/direct-volume/direct-volume';
var GaussianVolumeVisuals = {
  'gaussian-volume': function (ctx, getParams) {
    return ComplexRepresentation('Gaussian volume', ctx, getParams, GaussianDensityVolumeVisual);
  },
  'units-gaussian-volume': function (ctx, getParams) {
    return UnitsRepresentation('Units-Gaussian volume', ctx, getParams, UnitsGaussianDensityVolumeVisual);
  }
};
export var GaussianVolumeParams = __assign(__assign({}, GaussianDensityVolumeParams), {
  visuals: PD.MultiSelect(['gaussian-volume'], PD.objectToOptions(GaussianVolumeVisuals))
});
export function getGaussianVolumeParams(ctx, structure) {
  var p = PD.clone(GaussianVolumeParams);
  p.renderMode = DirectVolume.createRenderModeParam({
    // TODO find a better way to set
    min: 0,
    max: 1,
    mean: 0.04,
    sigma: 0.01
  });
  p.jumpLength = PD.Numeric(4, {
    min: 0,
    max: 20,
    step: 0.1
  });
  return p;
}
export function GaussianVolumeRepresentation(ctx, getParams) {
  return Representation.createMulti('Gaussian Volume', ctx, getParams, StructureRepresentationStateBuilder, GaussianVolumeVisuals);
}
export var GaussianVolumeRepresentationProvider = StructureRepresentationProvider({
  name: 'gaussian-volume',
  label: 'Gaussian Volume',
  description: 'Displays a gaussian molecular density using direct volume rendering.',
  factory: GaussianVolumeRepresentation,
  getParams: getGaussianVolumeParams,
  defaultValues: PD.getDefaultValues(GaussianVolumeParams),
  defaultColorTheme: {
    name: 'chain-id'
  },
  defaultSizeTheme: {
    name: 'uniform'
  },
  isApplicable: function (structure) {
    return structure.elementCount > 0;
  }
});